import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from '@mui/material'
import React from 'react'

const messages = {
    success: {
        title: '🎉 Thank You for Your Feedback!',
        message: `We truly appreciate your time and effort in sharing your thoughts with us. Our team will review your suggestion, and if necessary, we may follow up for more details.`,
        subMessage: `Thanks for being a valued part of our community! ❤️`,
    },
    error: {
        title: '⚠️ Oops! Something Went Wrong',
        message: `We encountered an unexpected issue while processing your request. Please try again later.`,
        subMessage: `If the problem persists, contact support for assistance.`,
    },
    validation: {
        title: '🚨 Please Check Your Input!',
        message: `It looks like some required information is missing or incorrect. Please review your details and try again.`,
        subMessage: `If you need help, feel free to reach out to support.`,
    },
    unauthorized: {
        title: '🔒 Access Denied',
        message: `You need to be logged in to perform this action. Please sign in and try again.`,
        subMessage: `If this is a mistake, contact support.`,
    },
    forbidden: {
        title: '⛔ Action Not Allowed',
        message: `It looks like you don’t have the necessary permissions to perform this action.`,
        subMessage: `If you believe this is an error, please contact your administrator.`,
    },
    notFound: {
        title: '🔍 Resource Not Found',
        message: `The requested item could not be found. It may have been moved, deleted, or never existed.`,
        subMessage: `Please check and try again.`,
    },
    timeout: {
        title: '⏳ Request Timed Out',
        message: `Our servers are taking longer than expected to respond. Please check your connection and try again.`,
        subMessage: `If the issue persists, reach out to support for help.`,
    },
    conflict: {
        title: '⚠️ Conflict Detected',
        message: `The action you are trying to perform conflicts with existing data.`,
        subMessage: `Please review your request and try again.`,
    },
}

const FeedbackPopover = ({ open, setIsOpen, type = 'success' }) => {
    const onClose = () => {
        setIsOpen(false)
    }

    const { title, message, subMessage } = messages[type] || messages.error

    return (
        <Dialog
            open={open}
            onClose={onClose}
            sx={{
                '& .MuiPaper-root': {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 3,
                    borderRadius: 3,
                    padding: 4,
                    backgroundColor: '#fff',
                },
            }}
        >
            <DialogTitle
                sx={{
                    color: '#333',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    fontSize: '1.5rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 1,
                }}
            >
                {title}
            </DialogTitle>

            <DialogContent>
                <Box
                    sx={{
                        textAlign: 'center',
                        color: '#555',
                        px: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 3,
                    }}
                >
                    <Typography variant="subtitle1" paragraph>
                        {message}
                    </Typography>
                    <Typography variant="subtitle1">{subMessage}</Typography>
                </Box>
            </DialogContent>

            <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
                <Button
                    onClick={onClose}
                    variant="contained"
                    sx={{
                        backgroundColor: 'var(--primary-color)',
                        textTransform: 'capitalize',
                        px: 3,
                        py: 1,
                        borderRadius: '8px',
                        fontSize: '1rem',
                    }}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default FeedbackPopover
